import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/// Subscribes to the OS-level reduced-motion preference. Returns `true` when
/// the user asked the system to minimise motion. Gate every non-essential
/// animation (celebrations, ambient drift, count-ups) on this, so users with
/// vestibular sensitivity get a quiet experience.
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const media = window.matchMedia(QUERY);
    const onChange = (e: MediaQueryListEvent): void => setReduced(e.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
